// extracted by mini-css-extract-plugin
export default {"skillsBanner":"Skills_skillsBanner__LVjLB","skill":"Skills_skill__r4TxJ"};